import { z } from 'zod';
import { TIPOS_SUMINISTRO } from '../dominio.js';
import { correo, opcional, ruc, uuid } from './comunes.js';
/**
 * ENTRADA — lo que el usuario escribe. Valida el formulario Y la API.
 *
 * Usa `opcional()`, que convierte los campos en blanco del formulario a null.
 * Eso es una transformación unidireccional: sirve para decodificar la entrada,
 * no para serializar la salida. Por eso el esquema de salida se declara aparte
 * y NO deriva de este: intentar reutilizarlo rompe la serialización.
 */
export const proveedorEntrada = z.object({
    codigo: opcional(z.string().trim().max(20)),
    razonSocial: z.string().trim().min(3, 'La razón social es obligatoria').max(250),
    ruc,
    domicilioFiscal: opcional(z.string().trim().max(300)),
    contactoNombre: opcional(z.string().trim().max(150)),
    telefono: opcional(z.string().trim().max(30)),
    correo: opcional(correo),
    // Muchos proveedores dan dos direcciones. Guardarlas en el mismo campo lo
    // invalidaría, y quedarse con una pierde un dato que el área usa.
    correoAlterno: opcional(correo),
    rubro: opcional(z.string().trim().max(150)),
    descripcion: opcional(z.string().trim().max(2000)),
    tipoSuministro: opcional(z.enum(TIPOS_SUMINISTRO)),
    formaPagoId: opcional(z.number().int().positive()),
    cuentaCorriente: opcional(z.string().trim().max(30)),
    cuentaCci: opcional(z.string().trim().max(30)),
    // Una orden en dólares no se paga en la cuenta de soles. El CCI es por
    // cuenta, así que la de dólares lleva el suyo.
    cuentaCorrienteUsd: opcional(z.string().trim().max(30)),
    cuentaCciUsd: opcional(z.string().trim().max(30)),
    cuentaDetraccion: opcional(z.string().trim().max(30)),
    observaciones: opcional(z.string().trim().max(2000)),
    activo: z.boolean().default(true),
});
/** Mismo motivo que en empresas: `.partial()` conserva los `.default()`, y
 *  editar el teléfono de un proveedor dado de baja lo reactivaba en silencio. */
export const proveedorEdicion = proveedorEntrada.partial().extend({
    activo: z.boolean().optional(),
});
/** SALIDA — lo que devuelve la API. Sin transformaciones: solo forma. */
export const proveedor = z.object({
    id: uuid,
    codigo: z.string().nullable(),
    razonSocial: z.string(),
    ruc: z.string(),
    domicilioFiscal: z.string().nullable(),
    contactoNombre: z.string().nullable(),
    telefono: z.string().nullable(),
    correo: z.string().nullable(),
    correoAlterno: z.string().nullable(),
    rubro: z.string().nullable(),
    descripcion: z.string().nullable(),
    tipoSuministro: z.enum(TIPOS_SUMINISTRO).nullable(),
    formaPagoId: z.number().nullable(),
    cuentaCorriente: z.string().nullable(),
    cuentaCci: z.string().nullable(),
    cuentaCorrienteUsd: z.string().nullable(),
    cuentaCciUsd: z.string().nullable(),
    cuentaDetraccion: z.string().nullable(),
    observaciones: z.string().nullable(),
    activo: z.boolean(),
    creadoEn: z.iso.datetime(),
    actualizadoEn: z.iso.datetime(),
});
export const filtroProveedores = z.object({
    activo: z.enum(['true', 'false']).optional(),
    tipoSuministro: z.enum(TIPOS_SUMINISTRO).optional(),
});
//# sourceMappingURL=proveedor.js.map